export default "__VITE_ASSET__snmGEE3F__"